/**
 * Keyboard shortcuts shared by the generated child grids.
 *
 * Kept out of the generator so the rule lives in one place: changing the binding is one edit
 * here, not a regeneration of every grid in the app.
 */

const isMac = (): boolean =>
  typeof navigator !== 'undefined' && /Mac|iPhone|iPad/.test(navigator.platform);

/**
 * "Commit this row and give me another": ⌘⏎ on macOS, Ctrl+⏎ elsewhere.
 *
 * Enter on its own already ends row editing in DataGrid, so the modifier is what separates
 * "done" from "done, next row". Deliberately not Alt+N — Option+N is a dead key on macOS
 * layouts and would type a diacritic into whichever field has focus.
 */
export function isAddRowShortcut(
  event: Pick<KeyboardEvent, 'key' | 'metaKey' | 'ctrlKey' | 'altKey' | 'shiftKey'>,
): boolean {
  return event.key === 'Enter' && (event.metaKey || event.ctrlKey) && !event.altKey && !event.shiftKey;
}

/** Tooltip label for a grid's New button: '⌘⏎' on macOS, 'Ctrl+Enter' elsewhere. */
export function addRowShortcutLabel(): string {
  return isMac() ? '⌘⏎' : 'Ctrl+Enter';
}
